import { render, staticRenderFns } from "./ComprehendKeyPhrases.vue?vue&type=template&id=21ccd6f0&"
import script from "./ComprehendKeyPhrases.vue?vue&type=script&lang=js&"
export * from "./ComprehendKeyPhrases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports